import { login, getInfo, getMenu } from '@/utils/api/login'
// import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: '',
    name: '',
    avatar: '',
    menu: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_MENU: (state, menu) => {
      state.menu = menu
    }
  },

  actions: {
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      return new Promise((resolve, reject) => {
        login(username, password)
          .then(response => {
            if (response.hasOwnProperty('status')) {
              if (response.status === -1) {
                reject()
                return
              }
            }
            if (response.hasOwnProperty('error')) {
              reject(response.error)
              return
            }
            commit('SET_TOKEN', response.access_token)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    async GetInfo({ dispatch, commit }) {
      return Promise.all([dispatch('GetUser'), dispatch('GetMenu')])
    },

    GetUser({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token)
          .then(response => {
            const data = response.data
            // commit('SET_ROLES', data.roles)
            commit('SET_NAME', data.username)
            resolve(response)
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    GetMenu({ commit, state }) {
      return new Promise((resolve, reject) => {
        getMenu(state.token)
          .then(response => {
            const data = response.data
            commit('SET_MENU', data)
            resolve(response)
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },

    LogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_NAME', '')
        commit('SET_MENU', [])
        resolve()
      })
    }
  }
}

export default user
